/*!
   angular-form-gen v0.0.1
   (c) 2014 (null) McNull https://github.com/McNull/angular-form-gen
   License: MIT
*/
(function(angular) {
